import React from "react";
import {
  Card,
  CardStackSection,
  Stack,
  Text,
  Heading,
  Button,
} from "@origin-digital/ods-core";

interface EICSubmittedPageProps {
  onGoBack: () => void;
}

const EICSubmittedPage: React.FC<EICSubmittedPageProps> = ({ onGoBack }) => {
  return (
    <CardStackSection variant="card-centered">
      <Card padding="medium" stretchY>
        <Stack space={["large", "xlarge"]} alignX="center">
          <img
            src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_success.svg"
            alt="Success"
          />
          <Stack space={["medium", "large"]}>
            <Heading variant="h4" align="center">
              Account holder details already received
            </Heading>
            <Text align="center">
              It looks like account holder details have already been submitted
              for this premise.
            </Text>
          </Stack>
          <Button variant="outlined" onClick={onGoBack}>
            Go back
          </Button>
        </Stack>
      </Card>
    </CardStackSection>
  );
};

export default EICSubmittedPage;
